import { Grade } from "types/types";
import { useFetchData, useGenericMutation } from "../useAxios";

export const useGetGrades = () =>
  useFetchData<Grade[]>({
    endpoint: "v1/grades",
    queryKey: ["grades"],
    showLoading: true,
  });

export const useSaveGrade = () =>
  useGenericMutation<{
    grades: Array<{
      id?: number;
      name: string;
      amount: number;
    }>;
  }>({
    endpoint: "v1/grades/",
  });
